import React, { useRef } from 'react';
import Toast from '../../components/Toast/toast.js';
import { useLanguage } from '../../utils/languageContext.js';
import { getTranslation } from '../../utils/translate.js';

const Development = () => {
    const { language } = useLanguage();
    const toastRef = useRef(null);
    
    const handleCleanCaches = () => {
        try {
            localStorage.clear();
            
            sessionStorage.clear();
            
            document.cookie.split(";").forEach(function(c) {
                document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
            });
            
            if ('caches' in window) {
                caches.keys().then(function(names) {
                    for (let name of names) {
                        caches.delete(name);
                    }
                });
            }
            
            toastRef.current?.addToast(
                getTranslation('development.cachesCleared', language) || 'All caches cleared successfully!',
                "success"
            );
            
            setTimeout(() => {
                window.location.reload();
            }, 1500);
        } catch (error) {
            console.error('Error clearing caches:', error);
            toastRef.current?.addToast(
                getTranslation('development.cachesClearFailed', language) || 'Failed to clear caches',
                "error"
            );
        }
    };

    return (
        <div className="container mx-auto px-4 py-8">
            <h1 className="text-xl font-bold mb-4 text-gray-900 dark:text-[#c9d1d9]">Development Menu</h1>
            
            <div className="bg-white rounded-lg shadow-md p-6 mb-6">
                <h2 className="text-xl font-semibold mb-4">Clean Caches</h2>
                <p className="text-gray-600 mb-4">
                    This will clear all browser storage (localStorage, sessionStorage, cookies) and reload the page.
                </p>
                <button
                    onClick={handleCleanCaches}
                    className="bg-red-600 hover:bg-red-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline transition duration-150"
                >
                    Clean All Caches
                </button>
            </div>
            <Toast ref={toastRef} />
        </div>
    );
};

export default Development;